module.exports = __webpack_public_path__ + "media/base/circle_info-5d6bbac7.svg";